<template>
    <div>
        <div class="content-page" v-if=storedStatusJWT>
            <h2 class="text-center pt2 pb-4">Варианты пополнения счета</h2>
            <div class="align-content-center text-center">
                <template>

                    <b-alert class="mb-4" variant="info" show>
                        <b>После отправки перевода не забываем</b><br>
                        Перевели:
                        <input v-model="pay"
                               style="margin-left: 5px; padding-left: 10px; height: 35px; width: 100px; font-size: 20px;"
                               placeholder="0" type="number">
                        <b-btn style="margin-top: -5px;" class="btn-success" @click="sendPay">сообщить</b-btn>
                        <div v-if="payStatus">Данные о переводе отправлены. Ожидайте пополнения.</div>
                    </b-alert>

                    <div v-if="this.region === 1" class="text-center">

                        <div class="mt-2">
                            <b-card-group deck class="pb-4">

                                <b-card header-bg-variant="light" class="text-center">
                                    <template #header class="card-header">
                                        <h4 class="mb-0 text-bold">На счёт ФОП Олег Линих.</h4>
                                    </template>
                                    <b-card-text>
                                        <div>
                                            <h2>Украина</h2>
                                           Внимание! Переводы делаем только на ФОП Олега Линиха.<br>
                                            На карты которые были до этого не отправляем!!! <br><br>

                                            IBAN счёт- UA 483052990000026005021102684<br>
                                            КОД 2314122079 <br>
                                            В назначении платежа обязательно указать - "За онлайн тренировки". <br><br>

                                            Для примера в privat24 надо:<br>
                                            Зайти: "Сервисы"- "Переводы" - "По реквизитам";<br>
                                            Ввести IBAN-счет получателя и Приватбанк автоматически подтянет реквизиты получателя; <br>
                                            Ввести сумму перевода и назначение платежа - "За онлайн тренировки" <br>
                                            Подтвердить перевод.<br><br>

                                            Для Монобанка:<br>
                                            Інші платежи -  Платіж за IBAN<br><br>

                                            Для других банков должно быть аналогично.<br><br>


                                            <h4>Не забываем после оплаты проинформировать через форму (вверху).</h4>
                                            В течении дня деньги поступают на Ваш лицевой счет.

                                            <br><br>
                                        </div>
                                    </b-card-text>
                                </b-card>

                            </b-card-group>
                        </div>

                    </div>
                    <div v-if="this.region === 2" class="text-center">
                        <!--USD-->
                        <div class="mt-2">
                            <b-card-group deck class="pb-4">

                                <b-card header-bg-variant="light" class="text-center">
                                    <template #header class="card-header">
                                        <h4 class="mb-0 text-bold">PayPal</h4>
                                    </template>
                                    <b-card-text>
                                        <div>
                                            <h2>Пополняем в долларах</h2>

                                            <div class="btn-paypal">
                                                <form action="https://www.paypal.com/donate" method="post"
                                                      target="_top">
                                                    <input type="hidden" name="hosted_button_id" value="8XVBQGVWCPTME"/>
                                                    <input type="image"
                                                           src="https://pics.paypal.com/00/s/YjM3ZmYwYmYtZmQ5NC00ZmE2LThhZmEtMDYxYzBhZjlkZGM0/file.PNG"
                                                           border="0" name="submit"
                                                           title="PayPal - The safer, easier way to pay online!"
                                                           alt="Donate with PayPal button"/>
                                                    <img alt="" border="0"
                                                         src="https://www.paypal.com/en_UA/i/scr/pixel.gif" width="1"
                                                         height="1"/>
                                                </form>
                                            </div>
                                            <h4>Не забываем после оплаты проинформировать через форму.</h4>
                                            В течении дня деньги поступают на Ваш лицевой счет.

                                            <br><br>
                                        </div>
                                    </b-card-text>
                                </b-card>
                                <b-card header-bg-variant="light" class="text-center">
                                    <template #header class="card-header">
                                        <h4 class="mb-0 text-bold">WesternUnion</h4>
                                    </template>
                                    <b-card-text>
                                        <div>
                                            <b>Реквизиты для оплаты:</b><br><br>
                                            1. Страна, город получателя Украина, г. Херсон Ukraine, Kherson<br>
                                            2. Сумма - любая.<br>
                                            3. Получатель: ФИО Олейник Виталий Владимирович<br>
                                            OLEYNIK VITALIY VLADIMIROVICH<br>
                                            4. моб. +38 (066) 798-76-98<br><br><br>
                                            <h4>Не забываем после оплаты проинформировать через форму.</h4>
                                            В течении дня деньги поступают на Ваш лицевой счет.

                                            <br><br>
                                        </div>
                                    </b-card-text>
                                </b-card>

                            </b-card-group>
                        </div>
                    </div>
                    <div v-if="this.region === 3" class="text-center">

                        <div class="mt-2">
                            <b-card-group deck class="pb-4">

                                <b-card header-bg-variant="light" class="text-center">
                                    <template #header class="card-header">
                                        <h4 class="mb-0 text-bold">На карту Монобанка</h4>
                                    </template>
                                    <b-card-text>
                                        На данный момент счет можно пополнить через сервис <a href="https://myxa.cc/">https://myxa.cc/</a><br>
                                        Регистрируетесь и проходите верификацию (на сайте есть информация). Первый раз будет долго, может занять время до суток.<br>
                                        После этого выбираете валюту отдачи RUB (нужную сумму) -> валюту получения UAH, выбираете систему "G-24 UAH" и вводите номер кошелька <b>1921 3647 1481 94</b>, и не забываем после оплаты
                                        проинформировать через форму (вверху).
                                        <br><br>
                                    </b-card-text>
                                </b-card>

                            </b-card-group>
                        </div>

                    </div>
                    <div v-if="this.region === 4" class="text-center">
                        <!--                EUR-->
                        <div class="mt-2">
                            <b-card-group deck class="pb-4">

                                <b-card header-bg-variant="light" class="text-center">
                                    <template #header class="card-header">
                                        <h4 class="mb-0 text-bold">PayPal</h4>
                                    </template>
                                    <b-card-text>
                                        <div>
                                            <h2>Пополняем в евро</h2>

                                            <div class="btn-paypal">
                                                <form action="https://www.paypal.com/donate" method="post"
                                                      target="_top">
                                                    <input type="hidden" name="hosted_button_id" value="UZQPW42QQV8G6"/>
                                                    <input type="image"
                                                           src="https://pics.paypal.com/00/s/N2FkMDE0YjgtNmJmOC00MDUzLWJhNDMtZTU0MzdkYmZkZGY2/file.PNG"
                                                           border="0" name="submit"
                                                           title="PayPal - The safer, easier way to pay online!"
                                                           alt="Donate with PayPal button"/>
                                                    <img alt="" border="0"
                                                         src="https://www.paypal.com/en_UA/i/scr/pixel.gif" width="1"
                                                         height="1"/>
                                                </form>
                                            </div>
                                            <h4>Не забываем после оплаты проинформировать через форму.</h4>
                                            В течении дня деньги поступают на Ваш лицевой счет.

                                            <br><br>
                                        </div>
                                    </b-card-text>
                                </b-card>
                                <b-card header-bg-variant="light" class="text-center">
                                    <template #header class="card-header">
                                        <h4 class="mb-0 text-bold">WesternUnion</h4>
                                    </template>
                                    <b-card-text>
                                        <div>
                                            <b>Реквизиты для оплаты:</b><br><br>
                                            1. Страна, город получателя Украина, г. Херсон Ukraine, Kherson<br>
                                            2. Сумма - любая.<br>
                                            3. Получатель: ФИО Олейник Виталий Владимирович<br>
                                            OLEYNIK VITALIY VLADIMIROVICH<br>
                                            4. моб. +38 (066) 798-76-98<br><br><br>
                                            <h4>Не забываем после оплаты проинформировать через форму.</h4>
                                            В течении дня деньги поступают на Ваш лицевой счет.

                                            <br><br>
                                        </div>
                                    </b-card-text>
                                </b-card>

                            </b-card-group>
                        </div>

                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import LoginForm from "./Login";
import Cookies from "js-cookie";
import router from './HomePage';
import {mapGetters} from 'vuex';


export default {
    data: () => ({
        pay: 0,
        payStatus: false,
        region: null,
        showDismissibleAlert: true
    }),
    computed: {
        ...mapGetters([
            'storedStatusJWT'
        ])
    },
    created() {
        if (this.storedStatusJWT) {
            this.axios
                .get('/api/region')
                .then(response => {
                    this.region = response.data;
                })
        } else {
            window.location.href = '/home';
        }
    },
    methods: {
        sendPay() {
            this.axios
                .get('/api/send_pay/' + this.pay)
                .then(response => {
                    this.payStatus = response.data;
                })
            setTimeout(() => {
                    this.payStatus = false
                    this.pay = 0;
                }
                , 6000);
        }
    }
}
</script>
<style>

.card-deck .card {
    box-shadow: 1px 5px 5px #dae0e5;
}

.btn-paypal {
    box-shadow: 2px 30px 30px #a0b0bd;
    width: 300px;
    height: 100px;
    margin: 20px auto 60px;
}

.card-deck {
    margin-right: 1px;
    margin-left: 1px;
}
</style>
